import { Box, Button, Flex, Heading, Input, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import PayPalButton from "./PayPalButton";
import { useToast } from "@chakra-ui/react"; // Import the toast hook
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Confirmation from "./Confirmation";
import {
  resetForm,
  submitFormFailure,
  submitFormSuccess,
} from "../reducers/bookingFormSlice";
import { resetBooking } from "../reducers/KiidoBookingSlice";
import { submitBookingApi } from "../api/api";

const getCurrentTimezone = () => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return timeZone;
};

const Payment = () => {
  const { t, i18n } = useTranslation();
  const toast = useToast(); // Initialize toast
  const dispatch = useDispatch();
  const { serviceType, bookingDetails } = useSelector((state) => state.booking);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [totalAmount, setTotalAmount] = useState(serviceType?.tariff); // Initial amount
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [bookingData, setBookingData] = useState({});
  const associationId = process.env.REACT_APP_ASSOCIATION_ID;

  const bookingState = useSelector((state) => state.booking);
  const { userFileNumberBool } = useSelector((state) => state.bookingForm);

  const handlePromoCodeValidation = () => {
    // Add your logic to validate the promo code here
    // For example, if promoCode is valid, adjust totalAmount
    if (promoCode === "DISCOUNT10") {
      setTotalAmount(totalAmount - 10); // Apply a 10€ discount
    }
  };


  useEffect(() => {
    console.log(bookingState, "bookingState", "bookings", userFileNumberBool);
  }, [bookingState, userFileNumberBool]);

  const closeConfirmation = () => {
    setConfirmationOpen(false);
    dispatch(resetForm());
    dispatch(resetBooking());
  };

  const handleSubmit = async () => {
    // console.log("bookingState ???? ", bookingState);
    console.log("bookingState ???? ", bookingState);

    const { bookingDetails } = bookingState;

    // Ensure participants array exists and has at least one participant
    const participants = bookingDetails?.participants || [];
    const firstParticipant = participants[0] || {};

    const bookingData = {
      date: bookingState?.dateAndTimeSlot?.selectedDate || null,
      time: bookingState?.dateAndTimeSlot?.selectedTimeSlot?.time || null,
      service: bookingState?.serviceId || null,
      language: i18n.language,
      additional_info: bookingDetails?.additional_info || null,
      association: `${associationId}`,
      tentative_availability_slot:
        bookingState?.dateAndTimeSlot?.selectedTimeSlot
          ?.tentative_availability_slot,
      service_concern: bookingState?.serviceType?.id || null,
      timezone: getCurrentTimezone(),
      participants: [
        {
          name: firstParticipant.name || null,
          status: firstParticipant.status || null,
          sex: firstParticipant.sex || null,
          city: firstParticipant.city || null,
          email: firstParticipant.email || null,
          phone: firstParticipant.phone || null,
        },
      ].filter((participant) => participant.name.trim() !== ""),
      ...(userFileNumberBool && { file_number: bookingDetails.file_Number }),
      current_url: window.location.href,
    };


    console.log("bookingData ===========> ", bookingData);

    try {
      let resData = await submitBookingApi(bookingData);
      // console.log("Response Data:", resData);

      dispatch(submitFormSuccess());

      if (resData?.checkoutlink) {
        window.location.href = resData.checkoutlink;
      } else {
        // Show toast on missing checkout link
        toast({
          title: t("content.checkout_failure"),
          description: t("content.no_checkout_link"),
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.log("Error:", error);
      dispatch(submitFormFailure(error.message));

      // Show toast on API error
      toast({
        title: t("content.booking_error"),
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <Box p={6} bg="white" borderRadius="md" boxShadow="md">
        <Heading as="h3" size="lg" mb={4} mt={4} color="#FF6666">
          {t("payment_summary")}
        </Heading>

        <Box border="1px" borderColor="gray.200" borderRadius="md" p={4}>
          <Box
            border="1px"
            borderColor="gray.200"
            borderRadius="md"
            p={2}
            mb={4}
          >
            {/* Session Information */}
            <Flex justify="space-between" align="center" mb={2}>
              <Box>
                <Text fontSize="sm" color="gray.500">
                  {t("session")}
                </Text>
                <Text>
                  {i18n.language === "fr"
                    ? serviceType.name_fr
                    : serviceType.name}{" "}
                  ({serviceType.tariff} - {serviceType.currency}) x 1{" "}
                  {t("person")}
                </Text>
              </Box>
              <Text fontWeight="bold">
                {serviceType.tariff} - {serviceType.currency}
              </Text>
            </Flex>
          </Box>
          {/* Promo Code Section */}
          <Box p={3} pb={0}>
            {/* <Flex align="center" mb={4}>
              <Text mr={2}>{t("promo_code")}</Text>
              <Input
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
                placeholder={t("enter_promo_code")}
                width="200px"
                mr={2}
              />
              <Button
                bg="transparent"
                color="#FF6666"
                border="2px solid #FF6666"
                _hover={{ bg: "#FF6666", color: "white" }}
                onClick={handlePromoCodeValidation}
              >
                {t("to_validate")}
              </Button>
            </Flex> */}

            {/* Total Amount */}
            <Flex justify="space-between" align="center">
              <Text>{t("total_amount")}</Text>
              <Text color="#FF6666" fontWeight="bold">
                {totalAmount} {serviceType.currency}
              </Text>
            </Flex>

            <Flex justify="flex-end" align="center" my={4}>
              <Button
                onClick={() => {
                  handleSubmit();
                }}
                minWidth="150px"
                bg="#FF6666"
                color="white"
                _hover={{ bg: "#E55353" }}
              >
                {t("pay_now")}
              </Button>
            </Flex>
          </Box>
        </Box>

        {/* <PayPalButton amount={totalAmount} onSuccess={handlePaymentSuccess} />
            {paymentStatus && <p>{paymentStatus}</p>} */}
      </Box>

      <Confirmation
        isOpen={confirmationOpen}
        onClose={closeConfirmation}
        data={bookingData}
      />
    </>
  );
};

export default Payment;
